import React from "react";
import { TextButton } from "../../controls";
import type { TextButtonProps } from "../../controls/Buttons/TextButton/TextButton";

export interface DialogButton extends Omit<TextButtonProps, "onClick"> {
  // Dialog buttons are invoked without the event (see getDialogButtons), so
  // the param is optional here, unlike TextButtonProps.onClick.
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  shouldStopPropagation?: boolean;
}

export const getDialogButtons = (
  buttons: DialogButton[],
  closeDialog: () => void,
) => {
  return buttons.map((btn, index) => {
    const props = {
      ...btn,
      onClick: (e?: React.MouseEvent) => {
        if (!!btn?.onClick) {
          btn?.onClick();
        }

        closeDialog();
        if (btn?.shouldStopPropagation) {
          // TextButton always invokes onClick with the event; `e` is non-null
          // whenever this branch runs. Assert to match the optional param type.
          e!.stopPropagation();
        }
      },
    };
    return (
      <TextButton
        data-testid={btn?.["data-testid"]}
        key={`dialog-btn-${index}`}
        {...props}
      />
    );
  });
};
